import { useShopStorefrontLocale } from '@/contexts/ShopStorefrontLocaleContext'

type Props = {
  /** Shop theme primary (hex) — label, border, and focus ring follow this color */
  primaryColor?: string
}

export function ShopLanguageSwitcher({ primaryColor = '#4f46e5' }: Props) {
  const { locale, setLocale, t, availableLocales } = useShopStorefrontLocale()

  return (
    <label className="flex items-center gap-2">
      <span
        className="whitespace-nowrap text-xs font-medium tracking-wide opacity-90 md:text-[13px]"
        style={{ color: primaryColor }}
      >
        {t('header.language')}
      </span>
      <select
        value={locale}
        aria-label={t('header.language')}
        onChange={(e) => setLocale(e.target.value)}
        className="max-w-[10rem] min-w-[7.5rem] cursor-pointer rounded-md border-2 bg-white/95 py-1 pl-2.5 pr-8 text-[13px] font-medium text-slate-800 shadow-sm transition-[border-color,box-shadow] focus:outline-none focus:ring-2 focus:ring-[color:var(--shop-primary)] focus:ring-offset-1 md:max-w-[11rem] md:min-w-[8rem] md:text-sm"
        style={{
          borderColor: `${primaryColor}55`,
          boxShadow: `0 1px 2px ${primaryColor}18`,
        }}
      >
        {availableLocales.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  )
}
